import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import EisenVault from "./EisenVault";
import Selectbox from "components/Forms/Elements/Selectbox";
import Translate from "helpers/Translate";

function Adapters({ clientData, fieldValues, onChange, errors }) {
  const [adapterName, setAdapterName] = useState("");

  useEffect(() => {
    setAdapterName(fieldValues.name);
  }, [fieldValues, errors]);

  const renderAdapter = () => {
    switch (adapterName) {
      case "eisenvault":
        return (
          <EisenVault
            clientData={clientData}
            fieldValues={fieldValues}
            errors={errors}
            onChange={e => {
              onChange(e);
            }}
          />
        );
      default:
        return "";
    }
  };

  return (
    <div>
      <div className="form-group">
        <Selectbox
          id="adapter"
          name="name"
          onChange={e => {
            setAdapterName(e.target.value);
            onChange(e);
          }}
          errors={errors}
          errorKey="adapter.name"
          fieldValue={adapterName}
          options={[
            {
              value: "",
              label: Translate({ id: "select_adapter" })
            },
            {
              value: "eisenvault",
              label: "EisenVault"
            }
          ]}
        />
      </div>
      {renderAdapter()}
    </div>
  );
}

Adapters.propTypes = {
  clientData: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  fieldValues: PropTypes.object,
  errors: PropTypes.object
};

export default Adapters;
